<template>
  <div class="step-survey">
    <div class="survey">
      <div class="survey-title">
        <div>
          <div class="number-container">
            <div
              class="number cursor-pointer"
              :class="step >= 1 && 'number__active'"
              @click="clickStep(1)"
            >
              1
            </div>
          </div>
          <p class="text">{{ $t("survey.general_info") }}</p>
        </div>
        <div class="distance-center">
          <div class="bridge-container">
            <div class="bridge" :class="step >= 2 && 'bridge__active'"></div>
          </div>
        </div>
        <div class="margin-left">
          <div class="number-container">
            <div
              class="number cursor-pointer"
              :class="step >= 2 && 'number__active'"
              @click="clickStep(2)"
            >
              2
            </div>
          </div>
          <p class="text">{{ $t("survey.survey_structure") }}</p>
        </div>
        <div class="distance-center">
          <div class="bridge-container">
            <div class="bridge" :class="step === 3 && 'bridge__active'"></div>
          </div>
        </div>
        <div class="margin-left">
          <div class="number-container">
            <div
              class="number cursor-pointer"
              :class="step === 3 && 'number__active'"
              @click="clickStep(3)"
            >
              3
            </div>
          </div>
          <p class="text">{{ $t("survey.email_content") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["step", "isReadOnly"],
  methods: {
    clickStep(step) {
      if (this.isReadOnly) this.$emit("clickStepSurvey", step);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-survey {
  max-width: 100% !important;
  display: flex;
  justify-content: center;
}

.survey-title {
  display: flex;
  width: 100%;
}

.survey-text {
  display: flex;
  justify-content: space-between;
}

.distance-center {
  display: flex;
  align-items: flex-start;
  width: 18rem;
}

.number-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.text {
  width: 200px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 12px 0;
  font-weight: 500;
  color: #1b1f22;
}

.number {
  font-size: 20px;
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 36px;
  font-weight: 400;
  color: #1b1f22;
  border: 4px solid #d8d8d8;
  z-index: 1;
}

.number__active {
  background-color: #ff7b00;
  color: white !important;
  border: 4px solid #ff7b00;
}

.bridge-container {
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: -5rem;
}
.bridge {
  width: 18rem;
  height: 0.2rem;
  background-color: #d8d8d8;
  z-index: 0;
}
.bridge__active {
  background-color: #ff7b00;
  animation-name: scale-width;
  animation-duration: 1s;
}
@keyframes scale-width {
  from {
    width: 0;
  }
  to {
    width: 18rem;
  }
}
.margin-left {
  margin-left: -10rem;
}
</style>
